module.exports = __webpack_public_path__ + "files/81f3e79e6413556cbe10c3cfec1a0080.png";